import Search from '@ingka/search';
import styled from '@emotion/styled';
import { useTableDataState } from "../../state/table-data.state";
import shallow from "zustand/shallow";
import { type FormEvent, useState, useEffect } from 'react';
import { tokens } from '../../../../shared/styles/core/tokens';

export const SearchBar = () => {
   const [query, setQuery] = useTableDataState((state) => [state.query, state.setQuery], shallow);
   const [search, setSearch] = useState(() => query.search || '');
   const [search2, setSearch2] = useState(() => query.search2 || '');

   useEffect(() => {
      setSearch(query.search || '');
      setSearch2(query.search2 || '');
   }, [query]);

   function setSearchQuery(value = '') {
      setQuery({
         ...query,
         search: value.trim() || undefined,
         offset: 0
      });
   }

   function setSearch2Query(value = '') {
      setQuery({
         ...query,
         search2: value.trim() || undefined,
         offset: 0
      });
   }

   function setSearchByEvent(e: FormEvent<HTMLInputElement>, cb: (v: string) => void) {
      if (!e.target || !(e.target instanceof HTMLInputElement)) return;
      cb(e.target.value || '');
   }

   return (
      <FlexedGrid>
         <StyledSearch
            id="search2"
            placeholder='Material grade'
            value={search2}
            onSearch={() => setSearch2Query(search2)}
            onClear={() => {
               setSearch2Query();
            }}
            onInput={(e) => setSearchByEvent(e, setSearch2)}
         />

         <StyledSearch
            id="search"
            placeholder='Item name'
            value={search}
            onSearch={() => setSearchQuery(search)}
            onClear={() => {
               setSearchQuery();
            }}
            onInput={(e) => setSearchByEvent(e, setSearch)}
         />
      </FlexedGrid>
   );
};

const FlexedGrid = styled.div`
   display: flex;
   align-items: center;
   gap: ${tokens.space.sm};
`;

const StyledSearch = styled(Search)`
  width: 20rem;
  height: 2.75rem;
  font-size: ${tokens.font.size.md};

  input {
    font-size: ${tokens.font.size.lg};
  }
`;